import React, { useState } from 'react';
import { Row, Col, Input, Space } from 'antd';
import { FilterValue, TablePaginationConfig } from 'antd/lib/table/interface';
import { DEFAULT_CURRENT_PAGE, DEFAULT_PAGE_SIZE } from 'constants/config';
import { isEmpty } from 'lodash';
import { GetUserRequest } from 'services/users';
import { UserTableWithPermission } from 'modules/user/components/UserList/withPermissionComponents';
import { useUpdateUserStatus } from 'hooks/userHooks';
import usersApi from 'services/users';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';

const UsersTab: React.FC = () => {
  const [filters, setFilters] = useState<GetUserRequest>({
    pageNo: DEFAULT_CURRENT_PAGE,
    limit: DEFAULT_PAGE_SIZE,
  });

  const { id: companyId } = useParams<{ id: string }>();
  const { isLoading, data, refetch } = useQuery(
    ['admin-users', companyId, filters],
    () => usersApi.getUsers(filters, { 'x-tenant-id': companyId as string }),
    { keepPreviousData: true },
  );
  const updateUserStatus = useUpdateUserStatus();

  const handlePageChange = (page: number, pageSize: number) => {
    setFilters({ ...filters, pageNo: page, limit: pageSize });
  };

  /* eslint-disable  @typescript-eslint/no-explicit-any */
  const handleTableChange = (
    pagination: TablePaginationConfig,
    tableFilters: Record<string, FilterValue | null>,
    sorter: any,
  ) => {
    setFilters({
      ...filters,
      pageNo: DEFAULT_CURRENT_PAGE,
      orderBy: sorter?.field ? sorter?.field : undefined,
      orderType: sorter?.order === 'ascend' ? 1 : -1,
    });
  };

  const handleSearch = (e: React.FormEvent<HTMLInputElement>) => {
    const value = e?.currentTarget?.value;
    setFilters({
      ...filters,
      pageNo: DEFAULT_CURRENT_PAGE,
      search: !isEmpty(value) ? value : undefined,
    });
  };

  const openUpdateUserStatusModal = () => {};

  return (
    <div>
      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col span={24} className="tableSearchBar">
          <Space align="end">
            <Input
              placeholder="Search users..."
              size="large"
              className="searchBar"
              onChange={handleSearch}
              allowClear
            />
          </Space>
        </Col>
      </Row>
      <UserTableWithPermission
        data={data}
        handleTableChange={handleTableChange}
        handlePageChange={handlePageChange}
        filters={filters}
        isLoading={isLoading}
        openUpdateUserStatusModal={openUpdateUserStatusModal as any}
        setFilters={setFilters}
        disabled={false}
        editPermission={true}
        setEditPermission={() => {}}
        changeStatusPermission={true}
        setChangeStatusPermission={() => {}}
        componentPermissions={[]}
        setPermission={() => {}}
      />
    </div>
  );
};

export default UsersTab;
